<div mat-dialog-title>
  <div data-testId="title" class="h4 mb-0">{{title}}</div>
  <button data-testId="close" mat-icon-button (click)="onCancel()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <ng-container [formGroup]="optionsForm" *ngFor="let option of data.options; trackBy: trackOptions">
    <div class="h4 align-item-center d-flex justify-content-between">
      <mat-checkbox [formControlName]="option.id" color="primary" [attr.data-testId]="option.name">
        <span>{{option.name}}</span>
      </mat-checkbox>
    </div>
  </ng-container>
</div>

<div mat-dialog-actions class="buttonsWrapper">
  <button mat-flat-button color="primary" (click)="onCopy()" cdkFocusInitial data-testId="copy">
    <mat-icon svgIcon="cloud-download"></mat-icon>
    <span>{{staticMessage.CopyButton | staticMessage}}</span>
  </button>
  <button mat-button color="primary" (click)="onCancel()" data-testId="cancel">
    {{staticMessage.CancelButton | staticMessage}}
  </button>
</div>
